export type FormResponderProgress = {
  activeStep: number
  currentStepIndex: number
  totalSteps: number
  isLastStep: boolean
  canGoBack: boolean
  label: string
}

export const hasFormResponderInput = (values: Record<string, unknown>): boolean =>
  Object.values(values).some((value) => {
    if (Array.isArray(value)) return value.length > 0
    return value !== undefined && value !== null && value !== '' && value !== false
  })

export const getFormResponderProgress = (steps: number[], stepIndex: number): FormResponderProgress => {
  const totalSteps = steps.length
  const maxIndex = Math.max(0, totalSteps - 1)
  const currentStepIndex = Math.min(Math.max(0, stepIndex), maxIndex)
  const activeStep = steps[currentStepIndex] ?? 0
  return {
    activeStep,
    currentStepIndex,
    totalSteps,
    isLastStep: totalSteps <= 1 || currentStepIndex >= totalSteps - 1,
    canGoBack: stepIndex > 0,
    label: `Step ${currentStepIndex + 1} of ${Math.max(1, totalSteps)}`,
  }
}
